import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-50 bg-black" }, null, -1)
const _hoisted_2 = { class: "flex justify-center items-center overflow-hidden fixed inset-0 z-60 outline-none focus:outline-none" }
const _hoisted_3 = {
  class: "flex flex-col items-center justify-center bg-white text-black-lp-300 rounded-3xl",
  style: {"width":"480px"}
}
const _hoisted_4 = { class: "flex items-center gap-x-5 px-6 py-5 border-b border-gray-lp-400 w-full" }
const _hoisted_5 = { class: "font-semibold text-xl" }
const _hoisted_6 = { class: "px-5 py-6 w-full flex flex-col justify-center items-center gap-y-6" }
const _hoisted_7 = {
  key: 0,
  class: "w-full flex flex-col gap-y-3"
}
const _hoisted_8 = { class: "font-semibold text-xl text-center" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = { class: "flex flex-col border border-gray-lp-1600 p-2 rounded-lg gap-y-1 text-sm" }
const _hoisted_11 = {
  key: 0,
  class: "flex items-center justify-between w-full"
}
const _hoisted_12 = { class: "whitespace-nowrap" }
const _hoisted_13 = { class: "font-bold text-right break-words" }
const _hoisted_14 = {
  key: 1,
  class: "flex items-center justify-between w-full"
}
const _hoisted_15 = { class: "whitespace-nowrap" }
const _hoisted_16 = { class: "font-bold text-right break-words" }
const _hoisted_17 = {
  key: 1,
  class: "w-full flex flex-col gap-y-3"
}
const _hoisted_18 = { class: "font-semibold text-xl text-center" }
const _hoisted_19 = { class: "w-full" }
const _hoisted_20 = { class: "flex flex-col gap-y-1 text-sm" }
const _hoisted_21 = {
  key: 0,
  class: "flex flex-col items-center w-full text-gray-lp-800"
}
const _hoisted_22 = { class: "whitespace-nowrap" }
const _hoisted_23 = { class: "font-bold text-right break-words" }
const _hoisted_24 = {
  key: 1,
  class: "flex flex-col items-center w-full text-gray-lp-800"
}
const _hoisted_25 = { class: "whitespace-nowrap" }
const _hoisted_26 = { class: "font-bold text-right break-words" }
const _hoisted_27 = { class: "flex gap-3" }
const _hoisted_28 = {
  key: 2,
  class: "text-red-lp-2400 text-center"
}
const _hoisted_29 = { class: "text-sm text-gray-lp-300 flex justify-center gap-1 w-full" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  key: 3,
  class: "text-sm text-red-lp-100 font-semibold bg-red-lp-1300 rounded-md px-5 py-2.5 text-center"
}
const _hoisted_33 = {
  key: 4,
  class: "w-full text-sm text-gray-lp-800 text-center"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("b", { class: "underline" }, "0811-8137-1273", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("b", { class: "underline" }, "system@thelionparcel.com ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _hoisted_1,
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Icons, {
                name: "arrow-up",
                class: "w-4 text-red-lp-100 cursor-pointer",
                style: {"rotate":"-90deg"},
                onClick: _ctx.onClose
              }, null, 8, ["onClick"]),
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("Verifikasi")), 1)
            ]),
            _createVNode("div", _hoisted_6, [
              (!_ctx.isWithContacts)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("Verifikasi Kode OTP")), 1),
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        (_ctx.maskedEmail)
                          ? (_openBlock(), _createBlock("div", _hoisted_11, [
                              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.titleEmail), 1),
                              _createVNode("span", _hoisted_13, _toDisplayString(_ctx.maskedEmail), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.maskedPhone)
                          ? (_openBlock(), _createBlock("div", _hoisted_14, [
                              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.titlePhoneNumber), 1),
                              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.maskedPhone), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_17, [
                    _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("Verifikasi Kode OTP")), 1),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        (_ctx.maskedEmail)
                          ? (_openBlock(), _createBlock("div", _hoisted_21, [
                              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("Masukkan kode OTP yang dikirimkan melalui email ke")), 1),
                              _createVNode("span", _hoisted_23, _toDisplayString(_ctx.maskedEmail), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.maskedPhone)
                          ? (_openBlock(), _createBlock("div", _hoisted_24, [
                              _createVNode("span", _hoisted_25, _toDisplayString(_ctx.titlePhoneNumber), 1),
                              _createVNode("span", _hoisted_26, _toDisplayString(_ctx.maskedPhone), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])),
              _createVNode("div", _hoisted_27, [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
                  return _createVNode("div", { key: i }, [
                    _withDirectives(_createVNode("input", {
                      ref: (el) => (_ctx.otpInputRefs[i - 1] = el),
                      type: "text",
                      inputmode: "numeric",
                      pattern: "[0-9]*",
                      "onUpdate:modelValue": ($event: any) => (_ctx.otp[i - 1] = $event),
                      maxlength: 1,
                      class: ["border rounded text-center text-xl font-medium focus:outline-none", {
                    'border-black-lp-300': _ctx.otp[i - 1] && !_ctx.changeEmailError,
                    'border-gray-lp-1300': !_ctx.otp[i - 1] && !_ctx.changeEmailError,
                    'border-red-lp-1700': _ctx.changeEmailError,
                  }],
                      style: {"width":"40px","height":"40px"},
                      onInput: ($event: any) => (_ctx.onInput($event, i - 1)),
                      onPaste: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args))),
                      onKeydown: [
                        ($event: any) => (_ctx.onKeyDown($event, i - 1)),
                        _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.verifyOtp && _ctx.verifyOtp(...args)), ["enter"]))
                      ]
                    }, null, 42, ["onUpdate:modelValue", "onInput", "onKeydown"]), [
                      [_vModelText, _ctx.otp[i - 1]]
                    ])
                  ])
                }), 64))
              ]),
              (_ctx.changeEmailError)
                ? (_openBlock(), _createBlock("div", _hoisted_28, _toDisplayString(_ctx.changeEmailError), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_LpButton, {
                title: _ctx.$t('Verifikasi'),
                color: "red-lp-100",
                textColor: "white",
                isWidthFull: "",
                fontWeight: "semibold",
                disabled: !_ctx.isOTPValid || _ctx.loadingVerifyOtp,
                onClick: _ctx.verifyOtp
              }, null, 8, ["title", "disabled", "onClick"]),
              _createVNode("div", _hoisted_29, [
                (!_ctx.canRequestOtp)
                  ? (_openBlock(), _createBlock("span", _hoisted_30, _toDisplayString(_ctx.$t("Kirim ulang kode OTP dalam")) + " " + _toDisplayString(_ctx.countDown), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_31, [
                      _createTextVNode(_toDisplayString(_ctx.$t("Belum menerima kode?")) + " ", 1),
                      _createVNode("button", {
                        class: "font-bold text-red-lp-100 cursor-pointer",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.requestOtp && _ctx.requestOtp(...args)))
                      }, _toDisplayString(_ctx.$t("Kirim Ulang")), 1)
                    ]))
              ]),
              (_ctx.getErrorMessage)
                ? (_openBlock(), _createBlock("div", _hoisted_32, _toDisplayString(_ctx.getErrorMessage), 1))
                : _createCommentVNode("", true),
              (_ctx.isWithContacts)
                ? (_openBlock(), _createBlock("div", _hoisted_33, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("Butuh bantuan? Hubungi via WhatsApp")) + " ", 1),
                      _hoisted_34,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("atau email ke")) + " ", 1),
                      _hoisted_35
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 64))
    : _createCommentVNode("", true)
}